/**
 * MVP 5 — PT links, invitations, roster APIs.
 */

import { apiFetch } from './client';

export interface MemberRow {
  userId: string;
  email?: string | null;
  role?: string;
}

export async function inviteUser(body: {
  email: string;
  role: 'client' | 'pt';
}): Promise<{
  inviteToken: string;
  temporaryPassword?: string;
  inviteCode?: string;
  inviteRole?: string;
}> {
  return apiFetch('/invitations', { method: 'POST', body });
}

export async function createPtLink(ptUserId: string, clientUserId: string): Promise<unknown> {
  return apiFetch('/pt-links', { method: 'POST', body: { ptUserId, clientUserId } });
}

export async function deletePtLink(ptUserId: string, clientUserId: string): Promise<unknown> {
  const pt = encodeURIComponent(ptUserId);
  const cl = encodeURIComponent(clientUserId);
  return apiFetch(`/pt-links/${pt}/${cl}`, { method: 'DELETE' });
}

export async function getPtClients(): Promise<{ ptUserId: string; clients: MemberRow[] }> {
  return apiFetch('/pt/clients');
}

export async function getClientsPt(): Promise<{
  clientUserId: string;
  trainers: MemberRow[];
}> {
  return apiFetch('/clients/pt');
}

export async function getMembers(): Promise<{ members: MemberRow[] }> {
  return apiFetch('/members');
}

export async function acceptInvite(token: string): Promise<void> {
  await apiFetch(`/invitations/${encodeURIComponent(token)}/accept`, { method: 'POST' });
}

export async function listPrograms(forUser?: string): Promise<{ programs: ProgramRow[] }> {
  const q = forUser ? `?userId=${encodeURIComponent(forUser)}` : '';
  return apiFetch(`/programs${q}`);
}

export interface ProgramRow {
  programId?: string;
  ownerUserId?: string;
  name?: string;
  assignedToUserIds?: string[];
}

export async function putProgram(
  programId: string,
  body: { name?: string; assignedToUserIds?: string[] },
): Promise<unknown> {
  return apiFetch(`/programs/${encodeURIComponent(programId)}`, { method: 'PUT', body });
}
